import { getAccessToken } from './auth';

export const NPS_RESULTS_URL = 'https://fp-api.focuspointintl.com/api/npsResults';

export const NPS_SURVEY_TYPES = ['oxr_ops', 'oxr_purchase', 'cap_ops'];

export const NPS_BUCKET_VALUES = ['detractor', 'passive', 'neutral', 'promoter'];

export function buildNpsResultsSearchParams({
  page = 1,
  unresolvedOnly = false,
  surveyTypes = [],
  npsBucket = '',
  submittedFrom = '',
  submittedTo = '',
  search = '',
}) {
  const params = new URLSearchParams({ page: String(page) });
  if (unresolvedOnly) params.set('unresolved', 'true');

  const types = (surveyTypes || []).filter((t) => NPS_SURVEY_TYPES.includes(t));
  if (types.length > 0) params.set('survey_type', types.join(','));

  const bucket = String(npsBucket || '').trim();
  if (bucket && NPS_BUCKET_VALUES.includes(bucket)) params.set('npsBucket', bucket);

  const from = String(submittedFrom || '').trim();
  if (from) params.set('submittedFrom', from);

  const to = String(submittedTo || '').trim();
  if (to) params.set('submittedTo', to);

  const term = String(search || '').trim();
  if (term) params.set('search', term);

  return params;
}

export function broadcastNpsUnresolvedCount(unresolved) {
  if (typeof unresolved !== 'number') return;
  window.dispatchEvent(new CustomEvent('nps-unresolved-count', { detail: { unresolved } }));
}

export async function fetchNpsUnresolvedCount() {
  const accessToken = await getAccessToken();
  if (!accessToken) return null;

  const params = new URLSearchParams({ page: '1', unresolved: 'true' });
  const response = await fetch(`${NPS_RESULTS_URL}?${params}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) return null;

  const data = await response.json();
  return typeof data.unresolved === 'number' ? data.unresolved : null;
}

export async function updateNpsResult(id, body) {
  const accessToken = await getAccessToken();
  if (!accessToken) throw new Error('Could not get access token');

  const response = await fetch(`${NPS_RESULTS_URL}/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || 'Failed to update NPS result');
  }

  return response.json();
}
